import { DiscoverGamesBulkUpdateButton } from "./components/DiscoverGamesBulkUpdateButton";
import { DiscoverGamesProgramGameButton } from "./components/DiscoverGamesProgramGameButton";
import { DiscoverGamesTableGrid } from "./components/DiscoverGamesTableGrid";
import { DiscoverGamesTableModals } from "./components/DiscoverGamesTableModals";
import { DiscoverGamesToolbar } from "./components/DiscoverGamesToolbar";
import { DISCOVER_GAMES_PAGE_SIZE_OPTIONS } from "./constants";
import { useDiscoverGamesTableController } from "./hooks/useDiscoverGamesTableController";
import "./DiscoverGamesTableV3.css";

/** @deprecated Use DISCOVER_GAMES_PAGE_SIZE_OPTIONS from ./constants */
export const PAGE_SIZE_OPTIONS = [...DISCOVER_GAMES_PAGE_SIZE_OPTIONS];

interface DiscoverGamesTableV3Props {
	/** Column visibility override */
	columnVisibility?: Record<string, boolean>;
	/** Storage key for column visibility persistence */
	storageKey?: string;
}

/**
 * Discover games table with filters, column visibility, and bulk row selection.
 * Render inside `DiscoverGamesBulkSelectProvider` (see `DiscoverGamesPageV3`).
 */
export function DiscoverGamesTableV3({
	columnVisibility: initialColumnVisibility = {},
	storageKey = "discoverGamesV3Columns",
}: DiscoverGamesTableV3Props) {
	const table = useDiscoverGamesTableController({ storageKey, initialColumnVisibility });

	return (
		<div className="discoverGamesTableV3">
			<DiscoverGamesToolbar
				filtersCollapsed={table.filters.filtersCollapsed}
				discoverGamesFilters={table.colConfig.discoverGamesFilters}
				filterValues={table.filters.filterValues}
				onFilterChange={table.handleFilterChange}
				onClearFilters={table.handleClearFilters}
				onToggleFiltersCollapse={table.filters.handleToggleFiltersCollapse}
				dynamicOptions={table.filters.dynamicOptions}
				visibleColumns={table.view.visibleColumns}
				bulkUpdateButton={
					<DiscoverGamesBulkUpdateButton
						disabled={table.batch.selectedCount === 0}
						canBulkUpdate={table.canBulkUpdate}
						tooltip={table.batch.bulkUpdateTooltip}
						onClick={() => table.batch.setShowBulkModal(true)}
					/>
				}
				onOpenColumnModal={() => table.view.setShowColumnModal(true)}
				selectedViewName={table.view.selectedViewName}
				programGameButton={
					<DiscoverGamesProgramGameButton
						canProgramGame={table.canProgramGame}
						onClick={table.programGameModal.open}
					/>
				}
			/>

			<DiscoverGamesTableGrid
				items={table.query.items}
				simpleColumns={table.simpleColumns}
				pagination={table.query.pagination}
				setPagination={table.query.setPagination}
				pageCount={table.query.pageCount}
				isLoading={table.query.isLoading}
				visibleColumns={table.view.visibleColumns}
				onColumnWidthsChange={table.view.handleColumnWidthsChange}
			/>

			<DiscoverGamesTableModals
				view={table.view}
				colConfig={table.colConfig}
				batch={table.batch}
				programGameModal={table.programGameModal}
				gameAnalysisModal={table.gameAnalysisModal}
			/>
		</div>
	);
}

export default DiscoverGamesTableV3;
